// extracted by mini-css-extract-plugin
export var radioInputRow = "L_vk";
export var radioInputColumn = "L_vl";
export var inputOptionRow = "L_qS";
export var inputOptionColumn = "L_qT";